<img src="assets/img/logo_big.svg" alt="Logo der Österreichischen Apothekerkammer"/>
<p>{{"LOGIN_ERROR.MESSAGE" | translate}}</p>
<div class="error-text">{{ errorString | translate }}</div>
<app-button (click)="retry()" label="{{'LOGIN_ERROR.BUTTON' | translate}}"></app-button>

